import { resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_page_header = _resolveComponent("ontos-page-header")!
  const _component_ontos_domain_input = _resolveComponent("ontos-domain-input")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_ontos_base = _resolveComponent("ontos-base")!

  return (_openBlock(), _createBlock(_component_ontos_base, _mergeProps(_ctx.baseProps, { ref: "base" }), {
    default: _withCtx(() => [
      (_ctx.loaded && _ctx.domain)
        ? (_openBlock(), _createBlock(_component_v_form, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_ontos_page_header, _normalizeProps(_guardReactiveProps(_ctx.heading)), null, 16),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ontos_domain_input, {
                        ref: "input",
                        value: _ctx.domainOnChange,
                        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.domainOnChange = $event)),
                        domains: _ctx.workspace.domains,
                        "fixed-alias": ""
                      }, null, 8, ["value", "domains"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "text-right"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        size: "small",
                        color: "primary",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.save())),
                        disabled: _ctx.edit.unchanged
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { start: "" }, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                              _createTextVNode("mdi-content-save", -1)
                            ]))]),
                            _: 1
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.$tt('save')), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16))
}